import { PRODUCT_MAP_SOURCE_CONFIG } from "../../constants";

export function parseProductsToGeoJSON(products) {
  let features = [];
  products.forEach(product => {
    if (product.locations) {
      product.locations.forEach(location => {
        features.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: location.coordinates
          },
          properties: {
            ...product,
            ...{ markerSource: product.imageSources[0] }
          }
        });
      });
    }
  });
  return {
    ...PRODUCT_MAP_SOURCE_CONFIG,
    ...{ data: { type: "FeatureCollection", features } }
  };
}
